module.exports = __webpack_public_path__ + "img/tnbsq_img.c1e3665f.png";